import React from 'react';
import styled from 'styled-components';
import { useSteppedProcess } from '../context';
const VerticalRuleWrapper = styled.div `
  ${({ isLastStep, theme: { space } }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    min-height: ${isLastStep ? '0' : '24px'};
    margin-right: ${space.sm};
  `}
`;
const BaseVerticalRule = styled.div `
  ${({ isLastStep, theme: { colors } }) => `
    width: 1px;
    height: 100%;
    background: ${colors['slate-2']};

    ${isLastStep ? 'display: none;' : ''}
  `}
`;
const VerticalRule = ({ stepIndex }) => {
    const { stepsMetadata } = useSteppedProcess();
    const isLastStep = stepIndex === stepsMetadata.length - 1;
    return (React.createElement(VerticalRuleWrapper, { isLastStep: isLastStep },
        React.createElement(BaseVerticalRule, { isLastStep: isLastStep, "data-testid": `mui-sp-vr-${stepIndex}` })));
};
export { VerticalRule };
//# sourceMappingURL=VerticalRule.js.map